import React, { ReactElement } from 'react';
import { Modal } from '../../../../components';
import { CommonIconEditIconModalIconPicker } from './components/CommonIconEditModalIconPicker';
import { CommonIconEditModalProps } from './container';
import { ConnectedCommonIconEditModalButtons } from './components/CommonIconEditModalButtons/container';
import { CommonIconEditModalCheckboxContainer } from './components/CommonIconEditModalCheckbox/container';
import { CommonIconEditModalCheckboxInfo } from './components/CommonIconEditModalCheckbox/components/CommonIconEditModalCheckboxInfo';

export const CommonIconEditModal = ({
  tabOrder,
  availableIcons,
  existingIcon,
  title,
  nodeUid,
  display,
  commonIconNodeTypeToEdit,
  setCommonIconNodeTypeToEdit,
  nodeType,
}: CommonIconEditModalProps): ReactElement => {
  if (commonIconNodeTypeToEdit !== nodeType) return <></>;

  return (
    <Modal
      onClose={() => setCommonIconNodeTypeToEdit(undefined)}
      show={true}
      title={title}
    >
      <form>
        <CommonIconEditIconModalIconPicker
          tabOrder={tabOrder}
          availableIcons={availableIcons}
          existingIcon={existingIcon}
        />
        <CommonIconEditModalCheckboxContainer isHidden={display?.hidden} />
        <CommonIconEditModalCheckboxInfo />
        <ConnectedCommonIconEditModalButtons
          existingIcon={existingIcon}
          nodeUid={nodeUid}
          display={display}
        />
      </form>
    </Modal>
  );
};
